import React from 'react';

import { createSafeContext } from 'core/Utils';

type AddCardContext = {
  error?: string;
  setError: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const [AddCardProvider, useAddCardProvider] = createSafeContext<AddCardContext>(
  'AddCardProvider  component was not found in tree'
);
